import { IMissionSensor } from '../missionPlan/IMissionSensor'

export interface IGliderConfig {
  libelle: string | null
  glider_type: string
  battery_type: string
  bms_type: string
  payload: Array<string>
  start_energy: number
  end_battery_percent: number
}

export function getDefaultGliderConfig({
  libelle = null as string | null,
  glider_type = 'SEAEXPLORER',
  battery_type = 'pack 18650',
  bms_type = 'neogy',
  payload = [] as Array<string>,
  start_energy = 29,
  end_battery_percent = 15,
} = {}) {
  return {
    libelle,
    glider_type,
    battery_type,
    bms_type,
    payload,
    start_energy,
    end_battery_percent,
  } as IGliderConfig
}
